module.exports = __webpack_public_path__ + "static/media/client-black.7d1bde23.svg";